// extracted by mini-css-extract-plugin
module.exports = {"root":"default_root__S2buY","date":"default_date__eJ6t0","author":"default_author__AAsRk"};